(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    (() => {
if (document.documentElement.dataset.novynCollectionPreview) return;
document.documentElement.dataset.novynCollectionPreview = 'true';
const states = new WeakMap();
function updatePreview(event) {
const item = event.target.closest?.('.novyn-nav-edit-grid > .mega-menu__list a');
if (!item) return;
const card = item.closest('.novyn-nav-edit-grid').querySelector('.novyn-nav-edit-feature');
if (!card || card.hasAttribute('data-novyn-shape-guide')) return;
const imageLink = card.querySelector('.novyn-nav-edit-image');
const img = imageLink.querySelector('img');
const title = card.querySelector('.novyn-nav-edit-title');
const description = card.querySelector('.novyn-nav-edit-description');
const cta = card.querySelector('.novyn-nav-edit-cta');
let state = states.get(card);
if (!state) {
state = { src: img.getAttribute('src'), alt: img.alt, href: imageLink.getAttribute('href'), label: imageLink.getAttribute('aria-label'), title: title.textContent, description: description.textContent, cta: cta.textContent, current: 'edit' };
states.set(card, state);
const preload = new Image();
preload.src = card.dataset.novynEverydayImage;
}
const isEveryday = new URL(item.href, location.href).pathname.split('/').filter(Boolean).pop() === 'everyday';
const isGetaway = new URL(item.href, location.href).pathname.split('/').filter(Boolean).pop() === 'getaway';
const isRomantic = new URL(item.href, location.href).pathname.split('/').filter(Boolean).pop() === 'romantic';
const isAutumn = new URL(item.href, location.href).pathname.split('/').filter(Boolean).pop() === 'early-fall';
const isBestSellers = new URL(item.href, location.href).pathname.split('/').filter(Boolean).pop() === 'best-sellers';
const isStatement = new URL(item.href, location.href).pathname.split('/').filter(Boolean).pop() === 'statement';
    const next = isBestSellers ? 'best-sellers' : isEveryday ? 'everyday' : isGetaway ? 'getaway' : isRomantic ? 'romantic' : isAutumn ? 'autumn' : isStatement ? 'statement' : 'edit';
if (state.current === next) return;
state.current = next;
img.src = isBestSellers ? card.dataset.novynBestSellersImage : isEveryday ? card.dataset.novynEverydayImage : isGetaway ? card.dataset.novynGetawayImage : isRomantic ? card.dataset.novynRomanticImage : isAutumn ? card.dataset.novynAutumnImage : isStatement ? card.dataset.novynStatementImage : state.src;
img.alt = isBestSellers ? 'Pink, blue and ocean-inspired nail designs on champagne satin, Best Sellers by Novyn' : isEveryday ? 'Pastel floral nails with an open storybook, Everyday by Novyn' : isGetaway ? 'Garden-inspired nails beside a sunlit pool, Getaway by Novyn' : isRomantic ? 'Pink floral nails and gold jewelry at a window-side dinner, Romantic by Novyn' : isAutumn ? 'Brown floral nails with maple leaves in warm autumn sunlight, Autumn by Novyn' : isStatement ? 'Iconic Kiss nails and diamond jewelry at an evening gala, Statement by Novyn' : state.alt;
const href = isBestSellers ? card.dataset.novynBestSellersUrl : isEveryday ? card.dataset.novynEverydayUrl : isGetaway ? card.dataset.novynGetawayUrl : isRomantic ? card.dataset.novynRomanticUrl : isAutumn ? card.dataset.novynAutumnUrl : isStatement ? card.dataset.novynStatementUrl : state.href;
imageLink.setAttribute('href', href);
imageLink.setAttribute('aria-label', isBestSellers ? 'Explore Best Sellers' : isEveryday ? 'Explore Everyday' : isGetaway ? 'Explore Getaway' : isRomantic ? 'Explore Romantic' : isAutumn ? 'Explore Autumn' : isStatement ? 'Explore Statement' : state.label);
cta.setAttribute('href', href);
title.textContent = isBestSellers ? 'Best Sellers' : isEveryday ? 'Everyday' : isGetaway ? 'Getaway' : isRomantic ? 'Romantic' : isAutumn ? 'Autumn' : isStatement ? 'Statement' : state.title;
description.textContent = isBestSellers ? 'Standout details. Effortless style.' : isEveryday ? 'A little detail for your daily rituals.' : isGetaway ? 'Color made for sunlit escapes.' : isRomantic ? 'Soft details. Lasting impressions.' : isAutumn ? 'Warm tones for golden afternoons.' : isStatement ? 'Made for a memorable entrance.' : state.description;
cta.textContent = isBestSellers ? 'Explore Best Sellers' : isEveryday ? 'Explore Everyday' : isGetaway ? 'Explore Getaway' : isRomantic ? 'Explore Romantic' : isAutumn ? 'Explore Autumn' : isStatement ? 'Explore Statement' : state.cta;
}
document.addEventListener('pointerover', updatePreview);
document.addEventListener('focusin', updatePreview);
})();
  } catch(e) { console.error(e); }
})();

})();
